import { MutationHookOptions, useMutation } from '@apollo/client';

import { CREATE_UNIT } from './mutations';

export const useCreateUnit = (options?: MutationHookOptions) => useMutation(CREATE_UNIT, options);
